import React from "react";
// Customizable Area Start
import { InputAdornment, FormHelperText, Box, Grid, Typography, TextField, Button, RadioGroup, FormControlLabel, Radio, Select, MenuItem, FormControl, FormLabel, IconButton } from "@mui/material";
import { logo, infoIcon, userIcon, calendarIcon } from "./assets";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Avatar from '@mui/material/Avatar';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const StyledButton = styled(Button)({
  textTransform: 'capitalize',
});
// Customizable Area End

import CustomisableUserProfilesController, {
  Props,
} from "./CustomisableUserProfilesController";
import NavigationMenu from "../../navigationmenu/src/NavigationMenu.web";

// Customizable Area Start
// Customizable Area End

export default class CustomisableUserProfiles extends CustomisableUserProfilesController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  renderLanguageOptions() {
    const options = [
      { value: 'english', label: 'English' },
      { value: 'spanish', label: 'Spanish' },
      { value: 'french', label: 'French' },
      { value: 'german', label: 'German' },
    ];

    return options.map((option) => (
      <MenuItem
        key={option.value}
        value={option.value}
        sx={{
          "&:hover": { backgroundColor: "#BBCF8D" },
          "&.Mui-selected": {
            backgroundColor: "transparent",
            color: "inherit"
          }
        }}
      >
        {option.label}
      </MenuItem>
    ));
  }
  render() {
    // Customizable Area Start
    return (
      // Customizable Area Start

      <Box sx={{ display: 'flex', minHeight: '100vh', width: '100%', height: '100%', overflowX: 'hidden' }}>
        {/* Sidebar */}
        <Box sx={{ minHeight: '100vh', flexGrow: 0, backgroundColor: '#ffffff', borderRight: '1px solid #cbd5e1', width: '115px', height: '100%', }}>
          <NavigationMenu id={""} navigation={this.props.navigation} />
        </Box>

        {/* Main Content */}
        <Box sx={{ height: '100%', flexGrow: 1, minHeight: '100vh', width: '100%', padding: 2, }}>
          <Box sx={{ margin: '22px', }}>
            <img
              data-test-id="back_arrow"
              onClick={(e) => {
                e.stopPropagation()
                this.props.navigation.navigate("LandingPage")
              }}
              src={logo}
              style={{ height: '24px', width: '148px', cursor: 'pointer' }}
              alt="Logo"
            />
          </Box>
          <Box sx={{
            padding: "32px",
            margin: "32px",
            borderTop: "1px solid #cbd5e1",
            minHeight: 'calc(100vh - 64px)',
            borderTopRightRadius: "8px",
            borderTopLeftRadius: "8px",
            display: 'flex',
            borderLeft: "1px solid #cbd5e1",
            borderRight: "1px solid #cbd5e1",
            flexDirection: 'column',
            flexGrow: 1
          }}>
            <Typography textAlign="left" sx={{ zIndex: 1, alignItems: 'center', fontFamily: "Inter", display: 'flex', fontWeight: "700", letterSpacing: "0%", fontSize: "14px", lineHeight: "22px" }}>
              {/* Added back icon */}
              <Box sx={{ mr: 1 }}>
                <ArrowBackIcon sx={{ cursor: "pointer" }} />
              </Box>
              Personal information
            </Typography>
            {/*ProfilePicture*/}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              width: '138px',
              padding: '10px',
              margin: '20px auto',
            }}>
              <Avatar
                onClick={() => {
                  if (this.fileInputRef.current) {
                    this.fileInputRef.current.click();
                  }
                }}
                data-test-id="profile_picture"
                style={{
                  width: '110px',
                  height: '110px',
                  backgroundColor: '#f5f6fa',
                  border: this.state.profileImage ? 'none' : '2px dashed #d1d0d3',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                }}
              >
                {/* Add file input */}
                <input
                  data-test-id = "file_input"
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={this.handleImageChange}
                  ref={this.fileInputRef}
                />
                {this.state.profileImage ? (
                  <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                    <img
                      src={this.state.profileImage}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                      alt="profile"
                    />
                    <div style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      height: '35px',
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                      <span style={{
                        fontFamily: 'Inter',
                        fontWeight: 700,
                        fontSize: '12px',
                        lineHeight: '24px',
                        textDecoration: 'underline solid',
                        letterSpacing: '0%',
                        color: '#000000',
                        cursor: 'pointer'
                      }}>
                        Change
                      </span>
                    </div>
                  </div>
                ) : (
                  <img
                    src={userIcon}
                    style={{
                      width: '40px',
                      height: '40px',
                      objectFit: 'contain',
                    }}
                    alt="add user"
                  />
                )}
              </Avatar>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                whiteSpace: 'nowrap',
              }}>
                <span style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '14px',
                  fontWeight: 700,
                  lineHeight: '22px',
                  color: '#000000',
                }}>Display Picture</span>
                <span style={{
                  color: 'red',
                  fontWeight: 700,
                }}>*</span>
                <img
                  src={infoIcon}
                  style={{
                    width: '18px',
                    height: '18px',
                    cursor: 'pointer',
                    marginLeft: '4px',
                  }}
                  alt="info"
                />
              </div>
            </div>
            <Grid container spacing={3} sx={{ flexGrow: 1, px: 4, marginBottom: '70px', }}>
              {/* Row 1 */}
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <FormLabel sx={{ color: 'black', fontWeight: 'bold', mb: 2 }}>
                    User Name<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                  </FormLabel>
                  <TextField
                    data-test-id="user_name_input"
                    value={this.state.userName}
                    onChange={(e) => this.handleUserNameChange(e)}
                    placeholder="Enter Name"
                    error={!!this.state.userNameError}
                    helperText={this.state.userNameError}
                    fullWidth
                    required
                    InputProps={{
                      style: { borderRadius: '8px', },
                      sx: {
                        height: '50px',
                        width: '90%',
                      }
                    }}
                    FormHelperTextProps={{ style: { marginLeft: '-1px' } }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <FormLabel sx={{ color: 'black', fontWeight: 'bold', mb: 2 }}>
                    Phone Number<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                  </FormLabel>
                  <Box sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                    <Select
                      value={this.state.countryCode}
                      sx={{
                        border: "1px solid #cbd5e1",
                        borderRadius: "12px",
                        height: "50px",
                        width: "20%",
                        minWidth: "76px"
                      }}
                      disabled
                      IconComponent={KeyboardArrowDownIcon}
                      renderValue={(value) => (
                        <span style={{ fontSize: 24 }}>
                          🇺🇸
                        </span>
                      )}
                    >
                    </Select>
                    <TextField
                      value={this.formatPhoneNumber(this.state.phone)}
                      disabled
                      fullWidth
                      required
                      InputProps={{
                        style: { borderRadius: '8px' },
                        sx: {
                          height: '50px',
                          width: '88%',
                          backgroundColor: '#E2E8F0',
                        }
                      }}
                    />
                  </Box>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <FormLabel sx={{ color: 'black', fontWeight: 'bold', mb: 2 }}>
                    Email<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                  </FormLabel>
                  <TextField
                    data-test-id="email_input"
                    value={this.state.emailAddress}
                    onChange={(e) => this.handleEmailChange(e)}
                    placeholder="Enter Email ID"
                    fullWidth
                    error={!!this.state.emailError}
                    helperText={this.state.emailError}
                    required
                    InputProps={{
                      style: { borderRadius: '8px' },
                      sx: {
                        height: '50px',
                        width: '90%'
                      }
                    }}
                    FormHelperTextProps={{ style: { marginLeft: '-1px' } }}
                  />
                </FormControl>
              </Grid>

              {/* Row 2 */}
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <FormLabel>
                    <Typography sx={{ color: 'black', fontWeight: 'bold', mb: 2, }}>
                      Gender<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                    </Typography>
                  </FormLabel>
                  <RadioGroup
                    data-test-id="gender_test"
                    value={this.state.gender}
                    onChange={(e) => this.handleGenderChange(e)}
                  >
                    <FormControlLabel
                      value="male"
                      control={<Radio sx={{ color: '#BBCF8D', '&.Mui-checked': { color: '#BBCF8D' } }} />}
                      label="Male"
                    />
                    <FormControlLabel
                      value="female"
                      control={<Radio sx={{ color: '#BBCF8D', '&.Mui-checked': { color: '#BBCF8D' } }} />}
                      label="Female"
                    />
                    <FormControlLabel
                      value="other"
                      control={<Radio sx={{ color: '#BBCF8D', '&.Mui-checked': { color: '#BBCF8D' } }} />}
                      label="Other"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <FormLabel sx={{ color: 'black', fontWeight: 'bold', mb: 2 }}>
                    About You
                  </FormLabel>
                  <TextField
                    data-test-id="about_input"
                    value={this.state.about}
                    onChange={(e) => this.handleAboutChange(e)}
                    placeholder="A Short Bio..."
                    fullWidth
                    multiline
                    rows={4}
                    InputProps={{
                      style: { borderRadius: '8px' },
                      sx: {
                        width: '90%'
                      },
                      inputProps: { maxLength: 200 }
                    }}
                  />
                  <FormHelperText sx={{ textAlign: 'right', mr: 6.5 }}>
                    {this.state.about.length}/200
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <FormLabel sx={{ color: 'black', fontWeight: 'bold', mb: 2 }}>
                    Areas of Expertise
                  </FormLabel>
                  <TextField
                    data-test-id="expertise_input"
                    value={this.state.areasOfExpertise}
                    onChange={(e) => this.handleAreasOfExpertiseChange(e)}
                    placeholder="Your Areas of Expertise"
                    fullWidth
                    multiline
                    rows={4}
                    InputProps={{
                      style: { borderRadius: '8px' },
                      sx: {
                        width: '90%'
                      },
                      inputProps: { maxLength: 100 }
                    }}
                  />
                  <FormHelperText sx={{ textAlign: 'right', mr: 6.5 }}>
                    {this.state.areasOfExpertise.length}/100
                  </FormHelperText>
                </FormControl>
              </Grid>

              {/* Row 3 */}
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <FormLabel sx={{ color: 'black', fontWeight: 'bold', mb: 2 }}>
                    DOB<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                  </FormLabel>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div data-test-id="dob_test">
                      <DatePicker
                        data-test-id="DatePickerMock"
                        label="DD/MM/YYYY"
                        value={this.state.dob}
                        onChange={this.handleDateChange}
                        format="DD/MM/YYYY"
                        maxDate={dayjs()}
                        open={this.state.isOpenDate}
                        onOpen={() => this.setState({ isOpenDate: true })}
                        onClose={() => this.setState({ isOpenDate: false })}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            InputProps: {
                              style: { borderRadius: '8px' },
                              sx: {
                                height: '50px',
                                width: '90%'
                              },
                              endAdornment: (
                                <InputAdornment position="end">
                                  <img
                                    data-test-id = "calendar_icon"
                                    src={calendarIcon}
                                    alt="Calendar Icon"
                                    style={{
                                      width: '25px',
                                      height: '25px',
                                      margin: '0.5px',
                                      cursor: 'pointer'
                                    }}
                                    onClick={() => this.setState({ isOpenDate: !this.state.isOpenDate })}
                                  />
                                </InputAdornment>
                              )
                            },
                            inputProps: {
                              'data-test-id': 'dob_input',
                              placeholder: 'DD/MM/YYYY',
                              required: true
                            }
                          }
                        }}
                      />
                    </div>
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <FormLabel sx={{
                    color: 'black', fontWeight: 'bold', mb: 2,
                    '&.Mui-focused': { color: 'black' }
                  }}>
                    Languages you know<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                  </FormLabel>
                  <Select
                    data-test-id="languages_test"
                    multiple
                    value={this.state.languages}
                    onChange={(e) => this.handleLanguagesChange(e)}
                    open={this.state.isOpen}
                    onOpen={() => this.setState({ isOpen: true })}
                    onClose={() => this.setState({ isOpen: false })}
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return <span style={{ color: '#94A3B8' }}>Select your languages</span>;
                      }
                      return (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {selected.map((language) => (
                            <Box
                              key={language}
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: '#D9D9D9',
                                borderRadius: '4px',
                                p: '4px 8px',
                                pr: '50px',
                                position: 'relative',
                                cursor: 'default',
                              }}
                            >
                              <span>{language.charAt(0).toUpperCase() + language.slice(1)}</span>
                              <IconButton
                                data-test-id="remove_language_button"
                                size="medium"
                                sx={{ position: 'absolute', right: '4px', top: '50%', transform: 'translateY(-50%)', color: 'black', }}
                                onMouseDown={(e) => {
                                  e.stopPropagation();
                                  this.removeLanguage(language);
                                }}
                              >
                                <CloseIcon
                                  data-test-id="remove_language_button"
                                  sx={{ fontSize: '16px' }} />
                              </IconButton>
                            </Box>
                          ))}
                        </Box>
                      );
                    }}
                    fullWidth
                    displayEmpty
                    className="custom-select"
                    style={{
                      borderRadius: '8px',
                      height: '50px',
                      width: '90%'
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                    sx={{
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#d3d3d3',
                      },
                    }}
                  >
                    {this.renderLanguageOptions()}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <FormLabel sx={{
                    color: 'black', fontWeight: 'bold', mb: 2,
                    '&.Mui-focused': { color: 'black' }
                  }}>
                    Location<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                  </FormLabel>
                  <Select
                    data-test-id="location_test"
                    required
                    value={this.state.location}
                    onChange={(e) => this.handleLocationChange(e)}
                    renderValue={(selected) => {
                      if (!selected) {
                        return <span style={{ color: '#94A3B8' }}>Select your country</span>;
                      }
                      return <span>{selected.charAt(0).toUpperCase() + selected.slice(1)}</span>;
                    }}
                    fullWidth
                    displayEmpty
                    className="custom-select"
                    style={{
                      borderRadius: '8px',
                      height: '50px',
                      width: '90%'
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                    sx={{
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#d3d3d3',
                      },
                    }}
                  >
                    <MenuItem sx={{ "&:hover": { backgroundColor: "#BBCF8D" } }} value="USA">USA</MenuItem>
                    <MenuItem sx={{ "&:hover": { backgroundColor: "#BBCF8D" } }} value="Canada">Canada</MenuItem>
                    <MenuItem sx={{ "&:hover": { backgroundColor: "#BBCF8D" } }} value="UK">UK</MenuItem>
                    <MenuItem sx={{ "&:hover": { backgroundColor: "#BBCF8D" } }} value="Australia">Australia</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* Row 4 */}
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <FormLabel sx={{ color: 'black', fontWeight: 'bold', mb: 2 }}>
                    City<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                  </FormLabel>
                  <TextField
                    data-test-id="city_test"
                    required
                    value={this.state.cityy}
                    onChange={(e) => this.handleCityChange(e)}
                    placeholder="Enter your city"
                    fullWidth
                    InputProps={{
                      style: { borderRadius: '8px' },
                      sx: {
                        height: '50px',
                        width: '90%'
                      }
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                {/* Empty space */}
              </Grid>
              <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: "center", alignItems: "center" }}>
                <StyledButton
                  data-test-id="nextButton"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.props.navigation.navigate("CustomisableUserProfilesScreen");
                  }}
                  variant="contained"
                  disabled={!(this.state.userName && this.state.phone && this.state.emailAddress && this.state.gender && this.state.dob && this.state.languages && this.state.location && this.state.cityy && this.state.countryCode && this.state.callingCode && this.state.profileImage)}
                  sx={{
                    marginRight: '35px',
                    width: '75%',
                    height: '50px',
                    borderRadius: '8px',
                    fontFamily: 'Inter',
                    fontWeight: 700,
                    fontSize: '16px',
                    lineHeight: '24px',
                    paragraphSpacing: '8px',
                    letterSpacing: '0%',
                    backgroundColor: !(this.props as any).disabled ? 'black' : '#default-color',
                    '&:hover': {
                      backgroundColor: !(this.props as any).disabled ? 'black' : '#default-color',
                    },
                  }}
                >
                  Next
                </StyledButton>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
      // Customizable Area End
    );

    // Customizable Area End
  }
}

// Customizable Area Start

// Customizable Area End
